/**
 * Check if value is nullish (`void`, `null` or `undefined`).
 * @param {*} value - Value that will be checked.
 * @returns {Boolean}
 */
export default function isNullish(value) {
    return value == null;
}
//# sourceMappingURL=main.js.map